import { httpRequest } from '@/services/httpClient'

export type Employee = {
  employeeId: number
  tenantId?: number
  organizationId?: number | null
  departmentId?: number | null
  employeeNumber?: string | null
  name: string
  surname?: string | null
  secondName?: string | null
  email?: string | null
  phone?: string | null
  birthDate?: string | null
  sex?: string | null
  hireDate?: string | null
  outDate?: string | null
  profileImage?: string | null
  isActive: boolean
  isDeleted: boolean
  locationId?: number | null
  unitId?: number | null
  subUnitId?: number | null
  positionId?: number | null
  titleId?: number | null
  jobId?: number | null
  employeeStatusId?: number | null
  employeeTypeId?: number | null
  driverLicenseId?: number | null
  militaryStatusId?: number | null
  licenseDate?: string | null
  employeeType?: string | null
  licenseClass?: string | null
  education?: string | null
  militaryStatus?: string | null
  salary?: number | null
  salaryCurrency?: string | null
  paymentFrequency?: string | null
  calculationType?: string | null
  paymentMethod?: string | null
  salaryWorkType?: string | null
  minimumWage?: boolean | null
  idTcNo?: string | null
  birthPlace?: string | null
  serialNo?: string | null
  validityDate?: string | null
  nationality?: string | null
  motherName?: string | null
  fatherName?: string | null
  neighborhood?: string | null
  street?: string | null
  buildingNo?: string | null
  apartmentNo?: string | null
  district?: string | null
  province?: string | null
  country?: string | null
  postalCode?: string | null
  emergencyContactName?: string | null
  emergencyContactPhone?: string | null
  emergencyContactRelation?: string | null
  maritalStatus?: string | null
  sscNo?: string | null
  sscStatus?: number | null
  insuranceStartDate?: string | null
  sscRegisteredName?: string | null
  sscRegisteredSurname?: string | null
  bankBranch?: string | null
  branchName?: string | null
  bankCode?: string | null
  bankName?: string | null
  incomeTaxExemption?: boolean | null
  stampTaxExemption?: boolean | null
  minimumWageIncomeTaxExemption?: boolean | null
  minimumWageStampTaxExemption?: boolean | null
  discountLaw?: string | null
  laborLaw?: string | null
  employeeDocumentType?: string | null
  rndLaw?: string | null
  employmentLaw?: string | null
  employmentIncentiveEndDate?: string | null
  disabilityDegree?: string | null
  disabilityRate?: number | null
  disabilityGroup?: string | null
  iban?: string | null
  accountNo?: string | null
  contractType?: string | null
  contractBegDate?: string | null
  contractEndDate?: string | null
  workCalendar?: string | null
  dutyType?: string | null
  workMode?: string | null
  monthlyWorkDays?: number | null
  weeklyWorkHours?: number | null
  trialPeriodMonths?: number | null
  trialPeriodEndSalary?: number | null
  deletedAt?: string | null
  createdAt: string
  lastUpdated?: string | null
  updatedAt?: string | null
}

export type EmployeesListResponse = {
  items: Employee[]
  totalCount: number
  page: number
  pageSize: number
}

export type EmployeesListParams = {
  tenantId?: number
  organizationId?: number | null
  departmentId?: number | null
  search?: string
  isActive?: boolean | null
  includeDeleted?: boolean
  page?: number
  pageSize?: number
  sortBy?: 'employeeNumber' | 'name' | 'surname' | 'hireDate' | 'lastUpdated'
  sortDir?: 'asc' | 'desc'
}

export type CreateEmployeePayload = {
  tenantId?: number
  employeeNumber: string
  name: string
  surname: string
  secondName?: string | null
  email?: string | null
  phone?: string | null
  birthDate?: string | null
  sex?: string | null
  hireDate?: string | null
  outDate?: string | null
  profileImage?: string | null
  organizationId?: number | null
  departmentId?: number | null
  locationId?: number | null
  unitId?: number | null
  subUnitId?: number | null
  positionId?: number | null
  titleId?: number | null
  jobId?: number | null
  employeeStatusId?: number | null
  employeeTypeId?: number | null
  driverLicenseId?: number | null
  militaryStatusId?: number | null
  licenseDate?: string | null
  employeeType?: string | null
  licenseClass?: string | null
  education?: string | null
  militaryStatus?: string | null
  salary?: number | null
  salaryCurrency?: string | null
  paymentFrequency?: string | null
  calculationType?: string | null
  paymentMethod?: string | null
  salaryWorkType?: string | null
  minimumWage?: boolean | null
  idTcNo?: string | null
  birthPlace?: string | null
  serialNo?: string | null
  validityDate?: string | null
  nationality?: string | null
  motherName?: string | null
  fatherName?: string | null
  neighborhood?: string | null
  street?: string | null
  buildingNo?: string | null
  apartmentNo?: string | null
  district?: string | null
  province?: string | null
  country?: string | null
  postalCode?: string | null
  emergencyContactName?: string | null
  emergencyContactPhone?: string | null
  emergencyContactRelation?: string | null
  maritalStatus?: string | null
  sscNo?: string | null
  sscStatus?: number | null
  insuranceStartDate?: string | null
  sscRegisteredName?: string | null
  sscRegisteredSurname?: string | null
  bankBranch?: string | null
  branchName?: string | null
  bankCode?: string | null
  bankName?: string | null
  incomeTaxExemption?: boolean | null
  stampTaxExemption?: boolean | null
  minimumWageIncomeTaxExemption?: boolean | null
  minimumWageStampTaxExemption?: boolean | null
  discountLaw?: string | null
  laborLaw?: string | null
  employeeDocumentType?: string | null
  rndLaw?: string | null
  employmentLaw?: string | null
  employmentIncentiveEndDate?: string | null
  disabilityDegree?: string | null
  disabilityRate?: number | null
  disabilityGroup?: string | null
  iban?: string | null
  accountNo?: string | null
  contractType?: string | null
  contractBegDate?: string | null
  contractEndDate?: string | null
  workCalendar?: string | null
  dutyType?: string | null
  workMode?: string | null
  monthlyWorkDays?: number | null
  weeklyWorkHours?: number | null
  trialPeriodMonths?: number | null
  trialPeriodEndSalary?: number | null
  isActive?: boolean
}

export type UpdateEmployeePayload = CreateEmployeePayload & {
  id: number
}

export type CreateUpdateResponse = {
  success: boolean
  data?: {
    id: number
    employeeNumber: string
    name: string
    surname: string
  }
  message?: string
}

export type EmployeeEducation = {
  id: number
  employeeId: number
  tenantId?: number
  educationLevel?: string | null
  schoolName?: string | null
  sectionName?: string | null
  graduationStatus?: string | null
  graduationYear?: number | null
  startYear?: number | null
  educationType?: string | null
  diplomaGrade?: string | null
  countryCity?: string | null
  diplomaNumber?: string | null
  isActive: boolean
  isDeleted: boolean
  deletedAt?: string | null
  createdAt: string
  updatedAt?: string | null
}

export type UpsertEmployeeEducationPayload = {
  tenantId?: number
  educationLevel?: string | null
  schoolName?: string | null
  sectionName?: string | null
  graduationStatus?: string | null
  graduationYear?: number | null
  startYear?: number | null
  educationType?: string | null
  diplomaGrade?: string | null
  countryCity?: string | null
  diplomaNumber?: string | null
  isActive?: boolean
}

export type EmployeeTimeOff = {
  id: number
  employeeId: number
  tenantId?: number
  timeOffType?: string | null
  startDate: string
  endDate: string
  durationDays?: number | null
  approvalStatus?: string | null
  notes?: string | null
  isActive: boolean
  isDeleted: boolean
  deletedAt?: string | null
  createdAt: string
  updatedAt?: string | null
}

export type UpsertEmployeeTimeOffPayload = {
  tenantId?: number
  timeOffType?: string | null
  startDate: string
  endDate: string
  durationDays?: number | null
  approvalStatus?: string | null
  notes?: string | null
  isActive?: boolean
}

export type EmployeeDocument = {
  id: number
  employeeId: number
  tenantId?: number
  name: string
  documentType?: string | null
  fileUrl?: string | null
  notes?: string | null
  documentDate?: string | null
  isActive: boolean
  isDeleted: boolean
  deletedAt?: string | null
  createdAt: string
  updatedAt?: string | null
}

export type UpsertEmployeeDocumentPayload = {
  tenantId?: number
  name: string
  documentType?: string | null
  fileUrl?: string | null
  notes?: string | null
  documentDate?: string | null
  isActive?: boolean
}

export type EmployeePerformance = {
  id: number
  employeeId: number
  tenantId?: number
  reviewDate: string
  score?: number | null
  reviewer?: string | null
  summary?: string | null
  isActive: boolean
  isDeleted: boolean
  deletedAt?: string | null
  createdAt: string
  updatedAt?: string | null
}

export type UpsertEmployeePerformancePayload = {
  tenantId?: number
  reviewDate: string
  score?: number | null
  reviewer?: string | null
  summary?: string | null
  isActive?: boolean
}

export type EmployeeTimesheet = {
  id: number
  employeeId: number
  tenantId?: number
  workDate: string
  workedHours: number
  overtimeHours?: number | null
  notes?: string | null
  isActive: boolean
  isDeleted: boolean
  deletedAt?: string | null
  createdAt: string
  updatedAt?: string | null
}

export type UpsertEmployeeTimesheetPayload = {
  tenantId?: number
  workDate: string
  workedHours: number
  overtimeHours?: number | null
  notes?: string | null
  isActive?: boolean
}

export type EmployeeLookupOption = {
  value: string
  label: string
}

export type EmployeeLookupsResponse = {
  genders: EmployeeLookupOption[]
  employeeTypes: EmployeeLookupOption[]
  positions: EmployeeLookupOption[]
  jobs: EmployeeLookupOption[]
  titles: EmployeeLookupOption[]
  militaryStatuses: EmployeeLookupOption[]
  maritalStatuses: EmployeeLookupOption[]
  driverLicenses: EmployeeLookupOption[]
  emergencyRelations: EmployeeLookupOption[]
  educationLevels: EmployeeLookupOption[]
  graduationStatuses: EmployeeLookupOption[]
  educationTypes: EmployeeLookupOption[]
  paymentFrequencies: EmployeeLookupOption[]
  calculationTypes: EmployeeLookupOption[]
  paymentMethods: EmployeeLookupOption[]
  salaryWorkTypes: EmployeeLookupOption[]
  workCalendars: EmployeeLookupOption[]
  dutyTypes: EmployeeLookupOption[]
  workModes: EmployeeLookupOption[]
  contractTypes: EmployeeLookupOption[]
  discountLaws: EmployeeLookupOption[]
  laborLaws: EmployeeLookupOption[]
  employeeDocumentTypes: EmployeeLookupOption[]
  rndLaws: EmployeeLookupOption[]
  employmentLaws: EmployeeLookupOption[]
  disabilityDegrees: EmployeeLookupOption[]
  bankBranches: EmployeeLookupOption[]
  timeOffTypes: EmployeeLookupOption[]
  approvalStatuses: EmployeeLookupOption[]
}

export const employeesApi = {
  list: (params: EmployeesListParams) =>
    httpRequest<EmployeesListResponse>('/v1/employees', {
      method: 'GET',
      query: {
        tenantId: params.tenantId,
        organizationId: params.organizationId ?? undefined,
        departmentId: params.departmentId ?? undefined,
        search: params.search?.trim() ? params.search.trim() : undefined,
        isActive: params.isActive === null ? undefined : params.isActive,
        includeDeleted: params.includeDeleted,
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 10,
        sortBy: params.sortBy,
        sortDir: params.sortDir,
      },
    }),

  getById: (id: number, tenantId?: number) =>
    httpRequest<Employee>(`/v1/employees/${id}`, {
      method: 'GET',
      query: { tenantId },
    }),

  create: (payload: CreateEmployeePayload) =>
    httpRequest<CreateUpdateResponse>('/v1/employees', {
      method: 'POST',
      body: payload,
    }),

  update: (payload: UpdateEmployeePayload) =>
    httpRequest<CreateUpdateResponse>(`/v1/employees/${payload.id}`, {
      method: 'PUT',
      body: payload,
    }),

  delete: (id: number) =>
    httpRequest<{ success: boolean; message?: string }>(`/v1/employees/${id}`, {
      method: 'DELETE',
    }),

  getLookups: () =>
    httpRequest<EmployeeLookupsResponse>('/v1/employees/lookups', {
      method: 'GET',
    }),

  educations: {
    list: (employeeId: number, tenantId?: number) =>
      httpRequest<{ items: EmployeeEducation[]; totalCount: number; page: number; pageSize: number }>(
        `/v1/employees/${employeeId}/educations`,
        { method: 'GET', query: { tenantId } },
      ),
    create: (employeeId: number, payload: UpsertEmployeeEducationPayload) =>
      httpRequest<CreateUpdateResponse>(`/v1/employees/${employeeId}/educations`, {
        method: 'POST',
        body: payload,
      }),
    update: (employeeId: number, id: number, payload: UpsertEmployeeEducationPayload) =>
      httpRequest<CreateUpdateResponse>(`/v1/employees/${employeeId}/educations/${id}`, {
        method: 'PUT',
        body: payload,
      }),
    delete: (employeeId: number, id: number) =>
      httpRequest<{ success: boolean; message?: string }>(`/v1/employees/${employeeId}/educations/${id}`, {
        method: 'DELETE',
      }),
  },

  timeOffs: {
    list: (employeeId: number, tenantId?: number) =>
      httpRequest<{ items: EmployeeTimeOff[]; totalCount: number; page: number; pageSize: number }>(
        `/v1/employees/${employeeId}/timeoffs`,
        { method: 'GET', query: { tenantId } },
      ),
    create: (employeeId: number, payload: UpsertEmployeeTimeOffPayload) =>
      httpRequest<CreateUpdateResponse>(`/v1/employees/${employeeId}/timeoffs`, {
        method: 'POST',
        body: payload,
      }),
    update: (employeeId: number, id: number, payload: UpsertEmployeeTimeOffPayload) =>
      httpRequest<CreateUpdateResponse>(`/v1/employees/${employeeId}/timeoffs/${id}`, {
        method: 'PUT',
        body: payload,
      }),
    delete: (employeeId: number, id: number) =>
      httpRequest<{ success: boolean; message?: string }>(`/v1/employees/${employeeId}/timeoffs/${id}`, {
        method: 'DELETE',
      }),
  },

  documents: {
    list: (employeeId: number, tenantId?: number) =>
      httpRequest<{ items: EmployeeDocument[]; totalCount: number; page: number; pageSize: number }>(
        `/v1/employees/${employeeId}/documents`,
        { method: 'GET', query: { tenantId } },
      ),
    create: (employeeId: number, payload: UpsertEmployeeDocumentPayload) =>
      httpRequest<CreateUpdateResponse>(`/v1/employees/${employeeId}/documents`, {
        method: 'POST',
        body: payload,
      }),
    update: (employeeId: number, id: number, payload: UpsertEmployeeDocumentPayload) =>
      httpRequest<CreateUpdateResponse>(`/v1/employees/${employeeId}/documents/${id}`, {
        method: 'PUT',
        body: payload,
      }),
    delete: (employeeId: number, id: number) =>
      httpRequest<{ success: boolean; message?: string }>(`/v1/employees/${employeeId}/documents/${id}`, {
        method: 'DELETE',
      }),
  },

  performances: {
    list: (employeeId: number, tenantId?: number) =>
      httpRequest<{ items: EmployeePerformance[]; totalCount: number; page: number; pageSize: number }>(
        `/v1/employees/${employeeId}/performances`,
        { method: 'GET', query: { tenantId } },
      ),
    create: (employeeId: number, payload: UpsertEmployeePerformancePayload) =>
      httpRequest<CreateUpdateResponse>(`/v1/employees/${employeeId}/performances`, {
        method: 'POST',
        body: payload,
      }),
    update: (employeeId: number, id: number, payload: UpsertEmployeePerformancePayload) =>
      httpRequest<CreateUpdateResponse>(`/v1/employees/${employeeId}/performances/${id}`, {
        method: 'PUT',
        body: payload,
      }),
    delete: (employeeId: number, id: number) =>
      httpRequest<{ success: boolean; message?: string }>(`/v1/employees/${employeeId}/performances/${id}`, {
        method: 'DELETE',
      }),
  },

  timesheets: {
    list: (employeeId: number, tenantId?: number) =>
      httpRequest<{ items: EmployeeTimesheet[]; totalCount: number; page: number; pageSize: number }>(
        `/v1/employees/${employeeId}/timesheets`,
        { method: 'GET', query: { tenantId } },
      ),
    create: (employeeId: number, payload: UpsertEmployeeTimesheetPayload) =>
      httpRequest<CreateUpdateResponse>(`/v1/employees/${employeeId}/timesheets`, {
        method: 'POST',
        body: payload,
      }),
    update: (employeeId: number, id: number, payload: UpsertEmployeeTimesheetPayload) =>
      httpRequest<CreateUpdateResponse>(`/v1/employees/${employeeId}/timesheets/${id}`, {
        method: 'PUT',
        body: payload,
      }),
    delete: (employeeId: number, id: number) =>
      httpRequest<{ success: boolean; message?: string }>(`/v1/employees/${employeeId}/timesheets/${id}`, {
        method: 'DELETE',
      }),
  },
}
